import $http from '@/libs/axios'

class AuthApis {
  static async validateEmail(email: string, password: string) {
    const data = {
      email,
      password,
    }
    return $http.post('/users/validate-email', data)
  }

  static async forgot(email: string) {
    const data = {
      email,
    }
    return (await $http.post('/users/reset-password', data)).data
  }

  static async reset(payload: any) {
    const data = {
      ...payload,
    }
    return (await $http.post('/users/password-reset', data)).data
  }

  static async social(provider: string, response: any) {
    return (await $http.post(`/users/social/${provider}`, response)).data
  }

  static async checkSocial(provider: string, response: any) {
    return (await $http.post(`/users/check-social/${provider}`, response)).data
  }

  static async wpToken() {
    return (await $http.get('/users/wp-token')).data
  }

  static async getUserFromToken(token?: string) {
    const headers = token ? { Authorization: `Bearer ${token}` } : {}
    $http.defaults.headers.common.Authorization = `Bearer ${token}`
    return $http.get('users/info', { headers })
  }
}
export default AuthApis
